/// <amd-module name="VSS/Features/Monaco/Components/DiffEditor" />
import { EditorBase } from "VSS/Features/Monaco/Components/EditorBase";
import { IDiffEditorProps, IEditorWidgetRegistration } from "VSS/Features/Monaco/Contracts";

export class DiffEditor extends EditorBase<IDiffEditorProps> {
    private diffComputed = false;

    protected setEditorContent(diffEditor: monaco.editor.IDiffEditor): void {
        if (diffEditor && this.props.originalContent !== undefined && !!this.props.modifiedContent) {
            const modifiedModel = this.createEditorModel(
                this.props.modifiedContent.content,
                this.props.modifiedContent.contentType,
                this.props.modifiedContent.contentUri
            );

            diffEditor.setModel({
                original: this.createEditorModel(this.props.originalContent, modifiedModel.getModeId(), undefined),
                modified: modifiedModel
            });

            diffEditor.setPosition({
                lineNumber: 1,
                column: 1
            });

            diffEditor.layout();
        }
    }

    protected createEditor(domElement: HTMLElement, options?: monaco.editor.IEditorConstructionOptions): monaco.editor.IDiffEditor {
        const diffEditor = monaco.editor.createDiffEditor(domElement, options);

        if (this.props.onContentUpdated) {
            diffEditor.getModifiedEditor().onDidChangeModelContent(() => this.sendThrottledContentChangedEvent());
        }

        return diffEditor;
    }

    protected addEditorWidgets(diffEditor: monaco.editor.IDiffEditor, widgetRegistrations: IEditorWidgetRegistration[]): void {
        if (diffEditor) {
            if (!this.diffComputed) {
                diffEditor.onDidUpdateDiff(() => {
                    if (!this.diffComputed) {
                        this.diffComputed = true;
                        super.addEditorWidgets(diffEditor, widgetRegistrations);
                    }
                });
            } else {
                super.addEditorWidgets(diffEditor, widgetRegistrations);
            }
        }
    }

    protected updateEditorContent(diffEditor: monaco.editor.IDiffEditor): void {
        if (diffEditor) {
            const model = diffEditor.getModel();
            if (model && this.props.modifiedContent) {
                if (this.props.modifiedContent && model.modified.getValue() !== this.props.modifiedContent.content) {
                    model.modified.setValue(this.props.modifiedContent.content);
                }
                if (this.props.originalContent && model.original.getValue() !== this.props.originalContent) {
                    model.original.setValue(this.props.originalContent);
                }
            }
        }
    }
}
